import React, { Component, Ref } from 'react'
import { Input as InputDefault, Textarea, Password } from './Input'
import { IInputProps } from './Input.types'
import Number from './variations/Number'
import { Radio } from './variations/Radio'
import { Checkbox } from './variations/Checkbox'
import { Switch } from './variations/Switch'

export class Input extends Component<IInputProps> {
  inputRef: Ref<HTMLInputElement>

  constructor(props: IInputProps) {
    super(props)
    this.inputRef = React.createRef()
  }

  static Checkbox = Checkbox

  static Switch = Switch

  static Number = Number

  static Password = Password

  static Radio = Radio

  static Textarea = Textarea

  render() {
    return <InputDefault ref={this.inputRef} {...this.props} />
  }
}

export * from './Input.types'
